import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];
  return (
    <section data-testid="marquee" className="border-y border-[var(--border)] bg-[var(--bg-secondary)] py-6 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        {items.map((m, i) => (
          <span key={i} className="flex items-center font-display text-3xl md:text-4xl text-neutral-700 mx-8">
            {m}
            <span className="inline-block w-2 h-2 bg-[var(--accent)] rounded-full ml-8" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
